import { PerforatingSchemeBase } from './base/perforating-scheme-base';

export class PerforatingScheme extends PerforatingSchemeBase { }